import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  margin-bottom: 15px;
  align-items: stretch;
  position: relative;
  border-radius: var(--border-radius);
  .autocomplete-input {
    width: 100%;
  }
  > p {
    margin: auto 10px;
  }
`;

export const Input = styled.input`
  touch-action: manipulation;
  outline: none;
  border-top: 0px;
  border-right: 0px;
  border-left: 0px;
  border-image: initial;
  width: 100%;
  line-height: normal;
  padding: 16px;
  margin: 0px;
  background: var(--input-background-color);
  border-radius: 8px 0 0 8px;
  border-width: 0px;
  border: ${({ failed }) => (failed ? '1px solid red' : '')};
  color: ${({ failed }) => (failed ? 'red' : 'var(--tertiary-color)')};
  border-right: 0;
  @media (max-width: 768px) {
    padding: 0.7rem 16px;
  }
`;

export const ClearInput = styled.div`
  cursor: pointer;
  line-height: normal;
  background-color: white;
  background: var(--input-background-color);
  padding-top: 15px;
  padding-right: 8px;
  border-radius: 0 8px 8px 0;
  border: ${({ failed }) => (failed ? '1px solid red' : '')};
  border-left: 0;
  &:hover {
    color: red;
  }
  @media (max-width: 768px) {
    padding-top: 0.7rem;
  }
`;

export const Error = styled.label`
  color: red;
  display: inline-block;
  padding-bottom: 0.7rem;
`;
